<div>
  <div class="container" style="min-height: 0; padding-top: 0; padding-bottom: 0;">
    <div class="select">
      <app-states-dropdown [initialState]="initialState" (selected)="selectState($event)"></app-states-dropdown>
    </div>
  </div>

  @for (listing of listings; track listing; let rowNumber = $index) {
    <div>
      @if (listing && officeStatus) {
        <app-lender-listing
          [listing]="listing" [rowNumber]="rowNumber + 1"
          [officeStatus]="officeStatus">
        </app-lender-listing>
      }
    </div>
  }
</div>
<app-trusted-partners></app-trusted-partners>
<app-product-options></app-product-options>
<app-state-rate-info></app-state-rate-info>